@if (tile.imageUrl) {
    <img
        ngSrcset="1x, 2x, 3x"
        class="marquee-background-image"
        [placeholder]="!(isServer && trackingPosition <= 1)"
        [width]="280"
        [height]="140"
        [priority]="trackingPosition <= 1"
        [ngSrc]="tile.imageUrl" />

    <div
        class="marquee-image-card"
        [ngClass]="{ 'card-special-image': !tile.source?.isAutomatedMarquee, 'card-special-image-automated': tile.source?.isAutomatedMarquee }">
        <ng-container *ngTemplateOutlet="marqueeWithOptionCardTemplate" />
    </div>
} @else {
    <ng-container *ngTemplateOutlet="marqueeWithOptionCardTemplate" />
}

<ng-template #marqueeWithOptionCardTemplate>
    @if (!preventNavigation) {
        <a dsTouchClick [href]="url" [vnSpeculativeLink]="url" [msRemoveHref]="shouldRemoveHref" (click)="tileClick()">
            <ng-container *ngTemplateOutlet="marqueeCardTemplate" />
        </a>
    } @else {
        <ng-container *ngTemplateOutlet="marqueeCardTemplate" />
    }
    @if (marketOverridenName) {
        <div class="market-type">
            <span class="line-span" [style.border-bottom-color]="tile.source?.textColor"></span>
            <span class="market-name-span" [title]="marketOverridenName" [style.color]="tile.source?.textColor"> {{ marketOverridenName }}</span>
            <span class="line-span" [style.border-bottom-color]="tile.source?.textColor"></span>
        </div>
    }
    <div>
        @if (tileOptionGroup) {
            @if (showDropDown && dropdownOptions) {
                <ms-dropdown
                    class="grid-dropdown"
                    [activeOption]="activeDropDownOption"
                    [options]="dropdownOptions"
                    [textColor]="tile.source?.textColor"
                    (optionChange)="optionSelected($event)" />
                @if (dropDownOptionGroup) {
                    <ms-option-group
                        class="option-group-dropdown"
                        [optionGroup]="dropDownOptionGroup"
                        [event]="tile.event"
                        [isOneWaySpecial]="false"
                        [optionNames]="overriddenOptionNames"
                        [showDropDown]="showDropDown"
                        [hasImage]="!!tile.imageUrl"
                        [tracking]="tracking"
                        [isFromPortal]="tile.isFromPortal" />
                }
            } @else {
                <ms-option-group
                    [optionGroup]="tileOptionGroup"
                    [event]="tile.event"
                    [isOneWaySpecial]="false"
                    [optionNames]="overriddenOptionNames"
                    [hasImage]="!!tile.imageUrl"
                    [isFromPortal]="tile.isFromPortal"
                    [tracking]="tracking"
                    [isLargeLockIcon]="marqueeConfig.marqueeVariant === v2MarqueeVariant" />
            }
        } @else {
            <div class="bet-now-bottom-alignment" [class.no-market-name]="!marketOverridenName">
                <ms-bet-now-button [event]="tile.event" />
            </div>
        }
    </div>
</ng-template>

<ng-template #marqueeCardTemplate>
    <div class="marquee-card-header">
        <div class="card-league" [title]="tile.event.league.name" [style.color]="tile.source?.textColor">
            <vn-icon name="sports-{{ tile.event.sport.id }}" class="icon-alignment" height="11" width="11" />
            <span>{{ tile.event.league.name }}</span>
        </div>
        <ms-scoreboard-time
            class="card-date"
            [event]="tile.event"
            [swapLiveBadge]="marqueeConfig.marqueeVariant === v2MarqueeVariant"
            [style.color]="tile.source?.textColor" />
    </div>
    <div [ngClass]="tileClass" [style.color]="tile.source?.textColor">
        @if (marqueeConfig.marqueeVariant === v2MarqueeVariant) {
            <div class="marquee-card-participants-body">
                <ng-container *ngTemplateOutlet="marqueeCardParticipantBody" />
            </div>
            @if (!!tile.event.scoreboard.score && tile.event.sport.id === sportConstant.Tennis) {
                <div class="marquee-card-scoreboard">
                    <ms-scoreboard [event]="tile.event" [showSportIcon]="marqueeConfig.marqueeVariant === v2MarqueeVariant" />
                </div>
            }
        } @else {
            <ng-container *ngTemplateOutlet="marqueeCardParticipantBody" />
        }
    </div>
</ng-template>

<ng-template #marqueeCardParticipantBody>
    @if (tile.event.participants.length > 1) {
        <div class="card-player card-player1">
            <div class="player-name" [ngClass]="truncationPlayer" [title]="tile.event.participants[0].shortName || tile.event.participants[0].name">
                {{ getParticipantName(0) }}
            </div>
            <ms-participant-image [participantImage]="images[0] || tile.event.participants[0].image" [sportId]="tile.event.sport.id" />
        </div>
    }
    @if (
        (tile.event.sport.id === sportConstant.Tennis && !!!tile.event.scoreboard.score) ||
        !(tile.event.sport.id === sportConstant.Tennis) ||
        marqueeConfig.marqueeVariant !== v2MarqueeVariant
    ) {
        <ms-scoreboard [event]="tile.event" [showSportIcon]="marqueeConfig.marqueeVariant === v2MarqueeVariant" />
    }

    @if (tile.event.participants.length > 1) {
        <div class="card-player card-player2">
            <ms-participant-image
                [shouldRotate]="true"
                [participantImage]="images[1] || tile.event.participants[1].image"
                [sportId]="tile.event.sport.id" />
            <div class="player-name" [ngClass]="truncationPlayer" [title]="tile.event.participants[1].shortName || tile.event.participants[1].name">
                {{ getParticipantName(1) }}
            </div>
        </div>
    }
</ng-template>
